import React from "react";
import { Box } from "rebass";
import { MdChevronRight } from "react-icons/md";

export const FolderActionIcon: React.FC = () => (
  <Box color="wild-blue">
    <MdChevronRight display="block" size={26} />
  </Box>
);
